import React, { useState } from 'react';
import BookBanner from '../components/BookBanner';
import Calendar from '../components/Calendar';
import ScheduleList from '../components/ScheduleList';
import SectionBanner from '../components/SectionBanner';
import styled from 'styled-components';
import { useNoobookContext } from '../context/NoobookContext';
import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserInfoQuery} from '../react-queries/queries';
import BookSearchPage from './BookSearchPage';
import BookRegisterPage from './BookRegisterPage';
import { FaTimes } from 'react-icons/fa';
import { BannerType } from '../common/enums';

const SectionTitle = styled.div`
  font-size: 22px;
  font-weight: bold;
  margin: 24px 0 12px 0;
  padding-left: 8px;
`;

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
`;

const ModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;

  &:hover {
    background: #f5f5f7;
  }
`;

const ModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;

const BookRegisterModal = ({ isbn, bookId, onClose }) => (
  <Modal>
    <ModalHeader>
      <ModalTitle>책 등록</ModalTitle>
      <CloseButton onClick={() => { if (window.confirm('등록 중인 내용이 저장되지 않습니다. 책 등록을 취소하시겠습니까?')) onClose(false); }}>
        <FaTimes />
      </CloseButton>
    </ModalHeader>
    <ModalContent>
      <BookRegisterPage propIsbn={isbn} propBookId={bookId} onClose={onClose} />
    </ModalContent>
  </Modal>
);

export function HomePage() {
  const { setShowBack, showBack } = useNoobookContext();
  const {data: userInfo} = useUserInfoQuery();
  const navigate = useNavigate();
  const [isBookRegisterOpen, setIsBookRegisterOpen] = useState(false);
  const [regIsbn, setRegIsbn] = useState(null);
  const [regBookId, setRegBookId] = useState(null);

  const handleBookSearchClose = (argIsbn, argBookId) => {
    if (!argIsbn && !argBookId) {
      //invalidateSchedules();
      return;
    }
    const result = window.confirm('선택한 도서를 등록(수정)하시겠습니까?');
    if (!result) {
      //invalidateSchedules();
      return;
    }
    setRegIsbn(argIsbn);
    setRegBookId(argBookId);
    setIsBookRegisterOpen(true);
  };

  const handleBookRegisterClose = (modified) => {
    setIsBookRegisterOpen(false);
    if(modified) {
      //invalidateSchedules();
    }
  };

  const onCalendarClick = useCallback(async(date) => {
    await navigate(`/record-calendar/${date.toISOString()}`);
  }, [navigate]);
  useEffect(() => {
    const prevShowBack = showBack;
    setShowBack(false);
    return () => {
      setShowBack(prevShowBack);
    };
  }, []);
  return (
    <>
      <div style={{padding: '0 12px'}}>
        <div style={{fontSize: '22px', fontWeight: 700, margin: '12px 0 0 0', paddingLeft: 4, color: '#3e3e3e'}}><span style={{fontWeight: 700}}>{userInfo?.name??userInfo?.loginid}님</span></div>
        <div style={{fontSize: '20px', color: '#3e3e3e', marginBottom: 12, paddingLeft: 4}}>오늘 이 책 어떠세요</div>
        <BookBanner bannerType={BannerType.MAIN} />
      </div>
      <div style={{cursor:'pointer'}}>
        <Calendar onCalendarClick={onCalendarClick}/>
      </div>
      <ScheduleList emptyMessage = '일정이 없습니다.<br />독서 기록을 남겨보세요'
                 emptyButtonLabel = '책등록하기'
                 onButtonClick = {() => navigate('/book-search')} />
      <div style={{padding: '0 12px 80px'}}>
        <BookSearchPage embeddedBookSearchOnly={true} onClose={handleBookSearchClose} />
        <SectionTitle style={{ color: '#3e3e3e', fontSize: '22px' }}>모임</SectionTitle>
        <BookBanner bannerType={BannerType.SUB_1} height={Math.round(200 * 2 / 3)} />
      </div>
      {isBookRegisterOpen && (
        <BookRegisterModal isbn={regIsbn} bookId={regBookId} onClose={handleBookRegisterClose} />
      )}
    </>
  );
} 